import { defineComponent as _defineComponent } from 'vue'
import { PasswordLongevity } from '@/lib/enum/PasswordLongeviy';
import { defineMessages } from '@/lib/i18n';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordSettingTable',
  props: {
  minimumPasswordLength: {
    type: Number,
    required: true,
  },
  passwordLongevity: {
    type: Number,
    required: true,
  },
  forDummy: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:minimumPasswordLength", "update:passwordLongevity"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:minimumPasswordLength', data: number): void;
  (e: 'update:passwordLongevity', data: number): void;
}), expose: any, slots: any, attrs: any }) {

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  minimumPasswordLength: 'パスワードの最低文字数',
  word: '文字',
  passwordExpirationPeriod: 'パスワードの有効期限',
  months: 'ヶ月',
  neverExpires: '無期限',
});

const passwordMinimumLengthOptions = [
  { text: '8', value: 8 },
  { text: '12', value: 12 },
  { text: '16', value: 16 },
];

const passwordLongevityOptions = [
  { text: $t(m.neverExpires), value: PasswordLongevity.UNLIMITED },
  { text: `1 ${$t(m.months)}`, value: PasswordLongevity.ONE_MONTH },
  { text: `3 ${$t(m.months)}`, value: PasswordLongevity.THREE_MONTHS },
  { text: `6 ${$t(m.months)}`, value: PasswordLongevity.SIX_MONTHS },
  { text: `12 ${$t(m.months)}`, value: PasswordLongevity.ONE_YEAR },
];





return { __sfc: true,$t, m, passwordMinimumLengthOptions, passwordLongevityOptions, emits }
}

})